import { Inject, Injectable } from '@angular/core';
import { Actions, createEffect, ofType } from '@ngrx/effects';
import { Action, Store } from '@ngrx/store';

import * as actions from '../actions/account-owner-collection.actions';
import * as accountOwnerServiceContracts from '../services/account-owner/contracts';

import { catchError, map, switchMap } from 'rxjs/operators';
import { Observable, of, from } from 'rxjs';
import * as sharedTypes from '../types';
import * as sharedActions from '../actions/layout.actions';
import * as coreConstants from '../../core/constants';

@Injectable()
export class AccountOwnerCollectionEffects {
  loadAccountOwnerList$: Observable<Action> = createEffect(() =>
    this.actions$.pipe(
      ofType(actions.load),
      switchMap((action) => {
        const request = new accountOwnerServiceContracts.GetAccountOwnerListRequest();
        request.name = action.name;
        return this.accountOwnerService.getAccountOwnerList(request).pipe(
          map((serviceResponse) => {
            return actions.loadSuccess({ payload: serviceResponse.entities });
          }),
          catchError((exc) => {
            if (exc.status === 500) {
              this.globalErrorHandler.handleError(exc, true);
              return from([sharedActions.showError({ payload: null }), actions.loadFail()]);
            }
            const { error, message } = exc;
            let msg = error.message || message || coreConstants.ERRORS_TEXTS.unavailableService;
            if (exc.status === 0) {
              msg = coreConstants.ERRORS_TEXTS.unavailableService;
            }
            this.notificationService.show(
              msg,
              sharedTypes.NotificationStyle.Bar,
              sharedTypes.NotificationType.Danger,
              sharedTypes.NotificationPosition.Top,
              0
            );
            return of(actions.loadFail());
          })
        );
      })
    )
  );

  constructor(
    private store$: Store<any>,
    private actions$: Actions,
    private globalErrorHandler: sharedTypes.GlobalErrorHandler,
    @Inject(sharedTypes.NOTIFICATION_SERVICE_TOKEN)
    private notificationService: sharedTypes.INotificationService,
    @Inject(accountOwnerServiceContracts.SERVICE_TOKEN)
    private accountOwnerService: accountOwnerServiceContracts.IAccountOwnerService
  ) {}
}
